import script from "./LegalPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalPortal.vue?vue&type=script&setup=true&lang=js"

import "./LegalPortal.vue?vue&type=style&index=0&id=b2250426&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2250426"]])

export default __exports__